import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"

import { forwardRef } from "react"

import styles from "./ThemeButton.module.scss"
import {
  SunFillIcon,
  MoonFillIcon,
} from "src/icons"

export interface Props extends ComponentPropsWithoutRef<"svg"> {
  appearance: "light" | "dark";
}

export const ThemeButtonIcon = forwardRef<SVGElement, Props>(
  function ThemeButtonIcon(props: Props, ref: Ref<SVGElement>) {
    const {
      appearance,
      ...svgProps
    } = props

    const className = classNames(
      props.className,
      styles.themeButtonIcon,
    )

    if (appearance === "light") {
      return (
        <SunFillIcon
          {...svgProps}
          className={className}
          ref={ref}
        />
      )
    }

    return (
      <MoonFillIcon
        {...svgProps}
        className={className}
        ref={ref}
      />
    )
  },
)
